import { TextField } from '@client/new/components/basic';
import { LandingMediaDropbox } from './MediaDropBox';
import { FieldTitle } from './RedStarTitle';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { useFormContext, Controller } from 'react-hook-form';
import { FieldDesc } from './common';
import { BulletsInput } from './BulletsInput';
import { TwoColumns } from './layouts';
import React from 'react';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  index: number;
};
export function HeroFullImageForm({ imageUpload, index }: Props) {
  const { register, control } = useFormContext();
  const r = (s) => register(`sections.${index}.${s}`);

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline'} optional />
        <FieldDesc>Text overlaid on video/image uploaded.</FieldDesc>
        <TextField
          {...r(`title`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
          multiline
          rows={3}
        />
      </div>

      <div>
        <FieldTitle title={'Bullets'} optional />
        <FieldDesc>
          Bullet points that communicate value proposition. Optional.
        </FieldDesc>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );

  const secondCol = (
    <Controller
      name={`sections.${index}.coverImage`}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          upload={imageUpload}
          inputRef={ref}
          label="Image"
          validationText="This image will be taking whole screen width. On mobile will be cropped to fit screen."
          value={value}
          onChange={onChange}
          type="image"
          icon={faImage as any}
          errorMsg={error?.message}
          width="320px"
          height="180px"
        >
          <ul className="text-black list-none text-center text-h12">
            <li>Image or GIF</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}
